import { defineComponent, toRef } from "vue";

export default defineComponent({
    name: "ButtonGold",
    props: {
        buttonData: {
            type: Object,
            required: true,
            default: () => {
                return {
                    name: "กรอกข้อมูล",
                    width: '144px'
                }
            }
        }
    },
    setup(props) {
        
        const button = toRef(props, "buttonData")

        return { button }
    },
});
